import { render, staticRenderFns } from "./teamReport.vue?vue&type=template&id=28058de7&scoped=true"
import script from "./teamReport.vue?vue&type=script&lang=js"
export * from "./teamReport.vue?vue&type=script&lang=js"
import style0 from "./teamReport.vue?vue&type=style&index=0&id=28058de7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28058de7",
  null
  
)

export default component.exports